export const PRINTFUL_SYNC_PRODUCT_VARIANTS_FIELDS_LIST: any = [
    {attribute: "id", label: "Id", cssClass: ''},
    {attribute: "main_category_id", label: "Main Category Id", cssClass: ''},
    {attribute: "external_id", label: "External Id", cssClass: ''},
    {attribute: "sync_product_id", label: "Sync Product Id", cssClass: ''},
    {attribute: "variant_id", label: "Variant Id", cssClass: ''},
    {attribute: "sku", label: "Sku", cssClass: ''},
    {attribute: "name", label: "Name", cssClass: ''},
    {attribute: "currency", label: "Currency", cssClass: ''},
    {attribute: "retail_price", label: "Retail Price", cssClass: ''},
    {attribute: "synced", label: "Synced", cssClass: ''},
    {attribute: "is_ignored", label: "Is Ignored", cssClass: ''},
    // {attribute: "warehouse_product_variant_id", label: "Warehouse Product Variant Id", cssClass: ''},
];


export const PRINTFUL_SYNC_PRODUCT_VARIANTS_INPUT_FIELDS: any = [
    {attribute: "id", label: "Id", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "external_id", label: "External Id", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "is_ignored", label: "Is Ignored", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "main_category_id", label: "Main Category Id", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "name", label: "Name", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "retail_price", label: "Retail Price", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "sku", label: "Sku", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "sync_product_id", label: "Sync Product Id", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "synced", label: "Synced", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "variant_id", label: "Variant Id", type: 'text', group: 'detail', cssClass: ''},
    {
        attribute: "warehouse_product_variant_id",
        label: "Warehouse Product Variant Id",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {attribute: "currency", label: "Currency", type: 'text', group: 'detail', cssClass: ''},
];
